var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cls},[_vm._t("default"),_vm._v(" "),(_vm.toastText!=='')?_c('zui-toast',[_vm._v("\n    "+_vm._s(_vm.toastText)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.loadingVisible)?_c('zui-loading'):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c3d1c08","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
// module id = null
// module chunks = 